import React from 'react';

import { withStyles } from 'tss-react/mui';
import { Paper, Typography, Grid, Container, Button, IconButton, CircularProgress } from '@mui/material'
import GetAppIcon from '@mui/icons-material/GetApp'
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';

import Termo from './Components/TermosFamilia';
import FeedBack from './Components/FeedBack';
import { authenticationService } from './services/auth_service';
import { userService } from './services/user_functions';



const useStyles = (theme, props) => ({
    main: {
        marginTop: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        // border:'1px solid green',
    },
    grid: {
        margin: theme.spacing(1),
        minWidth: '70vw',
        // border:'1px solid red',
    },
    gridItem:{
        // border:'1px solid black',
        margin: '5px',
    },
    button:{
        // border:'1px solid orange',
        color: 'black'

    },
    paper:{
        // Height: 'fit-content',
        marginBottom: '20px',
        minWidth: '90vw',
        maxWidth: 'fit-content',
        padding: '5px',
        // border:'1px solid purple',
    },
});
class ResultItem extends React.Component {
    openPDF = () => {
        const newTab = window.open('about:blank', '_blank')
        userService.downloadFile(this.props.child.PDF_Filename, 'open').then(response=>{
            const blobUrl = URL.createObjectURL(response.data);
            if (newTab){
                newTab.location.href = blobUrl;
                newTab.onload = ()=>URL.revokeObjectURL(blobUrl)
                this.props.openFeedBack()
            }
            
        }).catch(err=>{
            newTab?.close()
            if (err.response?.status === 404){
                window.alert("Não foi possível obter o arquivo.")
            }else if (err.response?.status === 403){
                window.alert("Não foi possível obter o arquivo.")
                window.location.reload()
            }
        })
    }

    downloadPDF = () => {
        userService.downloadFile(this.props.child.PDF_Filename, 'download').then(response=>{
            const blobUrl = URL.createObjectURL(response.data);
             const link = document.createElement('a');
            link.href = blobUrl;
            link.download = 'TesteDoPezinho.pdf'; 
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);
                }).catch(err=>{
                    console.log(err)
                    window.alert("Não foi possível obter o arquivo.")
                })
            this.props.openFeedBack()
            }
    render() {
        const {classes} = this.props
        return (
            <Paper className={classes.paper} elevation={3}>
                <Grid container>
                        <IconButton className={classes.button} title='Baixar arquivo' onClick={this.downloadPDF}><GetAppIcon /></IconButton> 
                        <IconButton className={classes.button} title='Abrir arquivo em nova guia' onClick={this.openPDF}><PictureAsPdfOutlinedIcon/></IconButton> 
                    <Grid>
                        <Typography className={classes.gridItem}><b>Nome Mãe:</b> {` ${this.props.child.prMotherFirstname} ${this.props.child.prMotherSurname}`}</Typography>
                        <Typography className={classes.gridItem}><b>Nome RN:</b> {` ${this.props.child.ptnFirstname? this.props.child.ptnFirstname:""} ${this.props.child.ptnSurname? this.props.child.ptnSurname:""}`}</Typography>
                    </Grid>
                    <Grid>
                        <Typography className={classes.gridItem}><b>Data Nasc bebê: </b>{new Date(this.props.child.DataNasc).toLocaleString("pt-BR").replace(", 00:00:00", "")}</Typography>
                        <Typography className={classes.gridItem}><b>Data coleta: </b>{new Date(this.props.child.DataColeta).toLocaleString("pt-BR").replace(", 00:00:00", "")}</Typography>
                    </Grid>
                </Grid>
                {/* <Typography>Os exames de investigação familiar para Hemoglobinopatias não estão disponíveis através desta plataforma</Typography> */}
            </Paper>
        )
    }
}
class Family extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            currentUser: this.props.userData,
            childrenData: null, // null = carregando | [] = sem registros | [...] = com dados
            
            // Inicializa já com o valor correto vindo do backend.
            // Se accept_terms === true → openAcceptTerms = false (não exibe termo)
            // Se accept_terms !== true → openAcceptTerms = true (exibe termo)
            // Evita flash indesejado da tela de Termos para quem já aceitou.
            openAcceptTerms: this.props.userData.accept_terms !== true,
            openFeedBack: false,
            feedBackWillOpen: true,
        }
        this.updateAcceptTerms = this.updateAcceptTerms.bind(this)
    }
    componentDidMount() {
        
        userService.listMyResults(this.state.currentUser.cpf).then(response => {
            // Resposta inválida da API (não é um objeto com .status)
            if (response === "ERRO") this.setState({ childrenData: [] })

            // Requisição bem sucedida — atribui os dados (pode ser array vazio []
            if (response.status === 200) {
                this.setState({ childrenData: response.data })
            }
        }).catch(e => {
            if (e.response) {
                // Servidor respondeu com erro HTTP
                let msg = "Houve um erro na conexão com o sistema. Tente novamente mais tarde."
                if (e.response.status >= 500) {
                    // Erro interno do servidor
                    this.setState({ childrenData: [], message: msg, openClose: true })
                } else if (e.response.status === 403) {
                    // Sessão expirada ou sem permissão → desloga o usuário
                    msg = e.response.data?.detail
                    this.setState({ childrenData: [], message: msg, openClose: true })
                    alert(msg) 
                    authenticationService.logoutFamilias(this.state.currentUser)
                } else {
                    // Outros erros HTTP (400, 404, etc.)
                    this.setState({ childrenData: [], message: msg, openClose: true })
                }
            } else {
                // Sem resposta do servidor: timeout ou sem internet (comum em celulares)
                // Sem esse bloco, childrenData ficaria null = loading infinito
                this.setState({
                    childrenData: [],
                    message: 'Sem conexão com o servidor. Verifique sua internet.',
                    openClose: true
                })
             }
        })
    }

    
    updateAcceptTerms () {
        userService.updateAcceptTerms(this.state.currentUser.cpf)
        .then(response => {
            if (response){
                if (response.status === 200){
                    this.setState({openAcceptTerms:false})
                }
            }
        })
    }

    handleAutomaticOpenFeedBack = () =>{
        if (this.state.feedBackWillOpen){
            this.handleOpenFeedBack()
            this.setState({feedBackWillOpen: false})
        }
    }

    handleOpenFeedBack = () => {

        this.setState({feedBackWillOpen: false})
        this.setState({openFeedBack: true})
    }

    handleCloseFeedback= ()=>{
        this.setState({openFeedBack: false})
    }


    render() {
        const { classes } = this.props;

        // 1. Exibe Termos antes de qualquer coisa.
        //    Inicializado no constructor, evita flash para quem já aceitou.
        if (this.state.openAcceptTerms) {
            return(
                    <Termo updateAcceptTerms={this.updateAcceptTerms} userData={this.state.currentUser}/>
            )
        }

        // 2. API ainda não respondeu — exibe loading
        if (this.state.childrenData === null) { 
                return (
                    <Container className={classes.main}>
                        <CircularProgress />
                        <Typography className={classes.grid} >Carregando...</Typography> 
                    </Container>
                ) 
        } 

        // 3. API respondeu mas sem registros vinculados ao CPF
        if (this.state.childrenData.length === 0) {
            return (
                <Container className={classes.main}>
                    <Typography className={classes.grid}>
                        Não há registros conectados ao seu CPF.
                    </Typography>
                </Container>
            )
        }

        // 4. Exibe os resultados
        return (
            <Container className={classes.main}>
                <Typography className={classes.grid}> Resultado do Teste do Pezinho de seu bebê </Typography>
                <Typography className={classes.grid} align='right'>
                    <Button onClick={this.handleOpenFeedBack} variant='outlined' > Nos Avalie! </Button>
                </Typography>
                    {
                        this.state.childrenData.map((value) => {
                            return (
                                <ResultItem child={value} classGrid={classes.grid} key={value.IDExport} openFeedBack={this.handleAutomaticOpenFeedBack} classes={classes}/>
                            )})
                    }
                <FeedBack open={this.state.openFeedBack} close={this.handleCloseFeedback} openAutomatic={this.handleAutomaticOpenFeedBack} openAutomaticTime={30000}/>
            </Container>
        );
        
    }
}
    
export default withStyles(Family, useStyles);

